import React, { ChangeEvent } from 'react';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import BaseRadioGroup from '@mui/material/RadioGroup';
import useStyles from './styles';

const RadioGroup = (props: RadioGroupPropTypes) => {
  const { classes } = useStyles();
  const { values, selectedValue, handleChange, label, name, ariaLabel } = props;

  return (
    <FormControl variant="standard" component="fieldset" className={classes.container}>
      {label && (
        <FormLabel component="legend" className={classes.legend}>
          {label}
        </FormLabel>
      )}
      <BaseRadioGroup
        aria-label={ariaLabel}
        name={name}
        value={selectedValue}
        onChange={handleChange}
      >
        {values.map((value: string) => (
          <FormControlLabel key={value} value={value} control={<Radio />} label={value} />
        ))}
      </BaseRadioGroup>
    </FormControl>
  );
};

export type RadioGroupPropTypes = {
  label?: string | React.ReactNode;
  selectedValue: string;
  handleChange: (event: ChangeEvent<HTMLInputElement>, value: string) => void;
  values: string[];
  name: string;
  ariaLabel: string;
};

export default RadioGroup;
